<template>
  <div v-if="steps">
    <div :id="id" class="stepper-container" :style="stepperStyle">
      <div
        :class="{
          step: true,
          'current-step': 'ready' == getStepStatus(index),
          'next-step': 'pending' == getStepStatus(index),
          'allow-cursor':clickable
        }"
        v-for="(step, index) in steps"
        :key="index"
        @click="stepClicked(index)"
        @mousewheel.prevent="scrollSteps"
      >
        <SAvatar
          v-if="'completed' == getStepStatus(index)"
          :fullname="getIndex(index)"
          :size="32"
          :radius="50"
          :color="'#a7e06b'"
          :fontColor="'#fff'"
          :fontSize="'20px'"
        />
        <SAvatar
          v-if="'ready' == getStepStatus(index)"
          :fullname="getIndex(index)"
          :size="32"
          :radius="50"
          :color="'#979797'"
          :fontColor="'#fff'"
          :fontSize="'20px'"
        />
        <SAvatar
          v-if="'pending' == getStepStatus(index)"
          :fullname="getIndex(index)"
          :size="32"
          :radius="50"
          :color="'#e1e1e1'"
          :fontColor="'#fff'"
          :fontSize="'20px'"
        />
        <div>{{ step.title }}</div>
      </div>
    </div>
    <!-- <transition-group name="slide-fade"> -->
      <slot> </slot>
    <!-- </transition-group> -->
  </div>
</template>

<script>
import SAvatar from "../components/SAvatar.vue";
import * as JSFunctions from "../Functions/Functions";

export default {
  name: "SStepper",
  data() {
    return {
        noOfSteps:0,
        prevStep:0,
        id:""
    };
  },
  props: {
    locale: {
      type: String,
      default: "en",
    },
    topButtons: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      required:true,
      default: function () {
        return [
          {
            stepNo: 1,
            title: "Sample title 1",
            status: "ready",
          },
          {
            stepNo: 2,
            title: "Sample title 2",
            status: "pending",
          },
        ];
      },
    },
    currentStep: {
      type: Number,
      default: 1,
      required: true
    },
    padding:{
      type:String,
      default:'24px 85px'
    },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {

    stepClicked(index) {
        // IF STEP CLICK IS NOT ALLOWED THEN RETURN THE CONTROL
        if(!this.clickable){
            return;
        }
        // IF THE BODY/CONTENT FOR A STEP IS MISSING THIS CONDITION WILL CHECK TRUE AND RETURN
        if(this.$children[(this.noOfSteps+index)] === undefined || this.$children[(this.noOfSteps+index)] === null){
            console.log("The body for this step is missing")
            return
        }
        // IF CURRENT STEP IS CLICKED THEN DO NOT UPDATE THE CURRENT STEP
        if((this.currentStep === index+1)){
            return;
        }
        // IF YOU TRY TO JUMP MULTIPLE STEPS AND ONE LESS THAN DESTINATION STEP IS NOT COMPLETED. RETURN/DO NOTHING
        if(index+1 > this.currentStep){
            if(this.steps[index-1].status === 'pending'){
                return;
            }
        }
        // console.log(this.noOfSteps,index,this.currentStep)
        // console.log(this.$children[(this.noOfSteps+index)].isActive," : ",this.$children[(this.noOfSteps+this.currentStep)-1].isActive,)

        // CHECK IF THE NEXT STEP'S CONTENT IS HIDDEN IF TRUE THE MAKE IT VISIBLE
        if(this.$children[(this.noOfSteps+index)].isActive === false){
            this.$children[(this.noOfSteps+index)].isActive = true;
        }
        // CHECK IF THE NEXT CURRENT STEP'S CONTENT IS VISIBLE IF TRUE THEN HIDE IT.
        if(this.$children[(this.noOfSteps+this.currentStep)-1].isActive === true){
            this.$children[(this.noOfSteps+this.currentStep)-1].isActive = false;
        }
        // EMITTING THE CHANGE TO MAKE SURE THAT THE PARENT COMPONENT CAN UPDATE THE STEPS ARRAY
        this.$emit("step-change", {
            currentStep: this.currentStep,
            nextStep: index + 1,
        });
    },

    getIndex(index) {
      let temp = index + 1 + "";
      if (temp.length === 1) {
        return index + 1 + "";
      } else {
        let mulDigStr = "";
        for (let i = 0; i < temp.length; i++) {
          // console.log(temp[i])
          mulDigStr += temp[i] + " ";
        }
        // console.log(mulDigStr)
        return mulDigStr;
      }
    },

    getStepStatus(index) {
      if (this.steps[index].status === "ready") {
        return "ready";
      }
      if (this.steps[index].status === "completed") {
        return "completed";
      }
      if (this.steps[index].status === "pending") {
        return "pending";
      }
    },

    scrollSteps(){
      // console.log(window.scrollX,event.deltaY,event.deltaX)
      let stepper = document.getElementById(this.id);
      stepper.scrollLeft+=event.deltaY
    }
  },
  computed: {
    stepperStyle() {
      return {
        display: "grid",
        "grid-template-columns": "repeat(" + this.steps.length + ", 160px)",
        padding:this.padding
      };
    },


    enterAnimation() {
      // if (this.currentStep.index < this.previousStep.index) {
      return "animated slow fadeInLeft";
      // } else {
      // return "animated quick fadeInRight";
      // }
    },
    leaveAnimation() {
      // if (this.currentStep.index > this.previousStep.index) {
      return "animated quick fadeOutLeft";
      // } else {
      // return "animated quick fadeOutRight";
      // }
    },
  },
  mounted() {
    // console.log("mounted")
    let x = document.getElementsByClassName("stepper-container");
    // console.log(x[0].children.length);
    this.noOfSteps = document.getElementsByClassName("stepper-container")[0].children.length;
    this.$children[this.noOfSteps].isActive = true;
    // console.log(this.$children);
  },
  created(){
    this.id = "stepper#"+JSFunctions.uuid();
  },
  watch:{
      currentStep: function(nv,ov){
      if(nv!=ov){
          // console.log(nv,ov);
          this.prevStep = ov;
          this.$children[(this.noOfSteps+this.currentStep)-1].isActive = true;
          this.$children[(this.noOfSteps+ov)-1].isActive = false;
        // this.$emit('selected-values',this.values);
      }
    },
  },
  beforeUpdate(){
    //   this.prevStep = this.currentStep;
    //   console.log(this.prevStep)
  },
  components: {
    SAvatar,
  },
};
</script>

<style lang="scss" scoped>
.stepper-container {
  // width: 100%;
  overflow-x: scroll;
  padding: 24px 85px 8px 85px;
  border-top: 1px solid var(--very-light-pink);
  align-items: center;
    font-family: "Roboto !important";
  box-shadow: 0 0 50px 0 var(--very-light-pink);
  background-color: rgba(255, 255, 255, 0);
  cursor: default;

  .step {
    width: 160px;
    display: grid;
    grid-template-columns: 32px 120px;
    column-gap: 8px;
    margin-right: 32px;
    font-size: 16px;
    line-height: 1.13;
    color: black;
    align-items: center;
  }
  .current-step {
    opacity: 1;
    font-weight: bold;
  }
  .next-step {
    opacity: 0.5;
  }
}
/* custom scrollbar */
::-webkit-scrollbar {
  //   width: 32px;
  height: 16px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
  width: 32px;
}

::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}
.slide-fade-enter-active {
  transition: all 0.8s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.5s ease-out cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.allow-cursor{
    cursor: pointer;
}
</style>